import { render, staticRenderFns } from "./ConsultationInfo.vue?vue&type=template&id=4f9db9af&scoped=true"
import script from "./ConsultationInfo.vue?vue&type=script&lang=js"
export * from "./ConsultationInfo.vue?vue&type=script&lang=js"
import style0 from "./ConsultationInfo.vue?vue&type=style&index=0&id=4f9db9af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9db9af",
  null
  
)

export default component.exports